// https://www.npmjs.com/package/js-datepicker#installation
// https://flaviocopes.com/how-to-get-tomorrow-date-javascript/
// https://css-tricks.com/everything-you-need-to-know-about-date-in-javascript/
const datepicker = require("js-datepicker");
const startDatepickerInput = document.querySelector("#startDate");


// Select start date for policy on summary page
if (startDatepickerInput) {
    const startDatepickerInputHidden = document.querySelector("#startDateHidden");
    const minDate = new Date();
    const selectedDate = $(startDatepickerInput).val() !== "" ? new Date($(startDatepickerInput).val()) : new Date();
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 30);
    const picker = datepicker(startDatepickerInput, {
        minDate: minDate,
        maxDate: maxDate,
        dateSelected: new Date(Math.max(selectedDate, minDate)),
        formatter: (input, date, instance) => {
            input.value = date.toDateString();
            // TODO: TE set input value format from data attribute
            if (typeof input.dataset.dateformat !== "undefined") {
                const dateFormat = input.dataset.dateformat;
                // console.log(dateFormat);
                input.value = date.toLocaleDateString(dateFormat);

            }
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
            startDatepickerInputHidden.value = date.toJSON().slice(0, 10);
        },
        onSelect: function (dateText) {
            $(this).change();
        }
    });
}